import { createActionConst } from '../../../utils/action.utils';

const SETTINGS_NAMESPACE = 'SETTINGS';

export const INITIAL_SETTINGS_PAGE = createActionConst(SETTINGS_NAMESPACE, 'INITIAL_SETTINGS_PAGE');

export const UPDATE_SETTINGS = createActionConst(SETTINGS_NAMESPACE, 'UPDATE_SETTINGS');

export const RESET_PRIMARY_COLORS = createActionConst(SETTINGS_NAMESPACE, 'RESET_PRIMARY_COLORS');

export const RESET_SECONDARY_COLORS = createActionConst(SETTINGS_NAMESPACE, 'RESET_SECONDARY_COLORS');

export const INTEGRATE_WRIKE = createActionConst(SETTINGS_NAMESPACE, 'INTEGRATE_WRIKE');
export const FETCH_WRIKE_FOLDERS = createActionConst(SETTINGS_NAMESPACE, 'FETCH_WRIKE_FOLDERS');
export const SYNC_WRIKE_FOLDERS = createActionConst(SETTINGS_NAMESPACE, 'SYNC_WRIKE_FOLDERS');
export const FETCH_WRIKE_FOLDER_MEETINGS = createActionConst(SETTINGS_NAMESPACE, 'FETCH_WRIKE_FOLDER_MEETINGS');

export const STORE_IS_FETCHED = createActionConst(SETTINGS_NAMESPACE, 'STORE_IS_FETCHED');
export const CLEAR_IS_FETCHED = createActionConst(SETTINGS_NAMESPACE, 'CLEAR_IS_FETCHED');
